import { CompanyApi } from 'api/CompanyApi';
import { CompanyModel } from 'api/dto/Company.dto';
import { ProjectModel } from 'api/dto/Project.dto';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'company';

export namespace CompanyState {
  type CompanyList = CompanyModel[];
  type CompanyProjectList = ProjectModel[];
  type CompanyListResource = Resource<CompanyList>;
  type CompanyProjectListResource = Resource<CompanyProjectList>;
  type MergeConnectionList = CompanyApi.MergeConnection[];
  type MergeConnectionListResource = Resource<MergeConnectionList>;

  export type Domain = {
    listResource: CompanyListResource;
    projectListResource: CompanyProjectListResource;
    mergeConnectionsResource: MergeConnectionListResource;
  };

  export const INITIAL_DOMAIN: Domain = {
    listResource: Resource.createPendingResource<CompanyList>(),
    projectListResource: Resource.createPendingResource<CompanyProjectList>(),
    mergeConnectionsResource: Resource.createPendingResource<MergeConnectionList>(),
  };
}
